import { useEffect, useState } from "react";

function formatTime(ms, format = (hours, minutes, seconds) => `${hours}h ${minutes}m ${seconds}s`) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return format(hours, minutes, seconds);
}

export default function useCountdown(targetTime) {
  const [timeLeft, setTimeLeft] = useState(targetTime - Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      // console.log('useCountdown')
      const diff = targetTime - Date.now();
      setTimeLeft(diff);
      if (diff <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);

  return timeLeft <= 0 ? 'Ended' : formatTime(timeLeft);
}
